import { render, staticRenderFns } from "./readonlyContent.vue?vue&type=template&id=afbb7e56&scoped=true&"
import script from "./readonlyContent.vue?vue&type=script&lang=babel&"
export * from "./readonlyContent.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afbb7e56",
  null
  
)

export default component.exports